<template>
	<footer>
		<div class="wrapper">
			<p>
				carmarkt.net &mdash;
				<router-link to="/imprint">Impressum</router-link>
				&mdash;
				<router-link to="/privacy">Datenschutz</router-link>
			</p>
		</div>
	</footer>
</template>

<style lang="scss">
$background-color: #28373B;
$base-color: #B10B16;
html, body, #app {
	height: 100%;
}
#app {
	display: flex;
	flex-direction: column;
}
#content {
	flex: 1;
}
footer {
	background: $background-color;
	padding: 8px;
	// border-top: 2px solid $base-color;
	p {
		margin: 0;
		padding: 0;
		text-align: right;
		font-size: 9pt;
		color: #fff;
		a {
			text-decoration: none;
			color: #fff;
			font-weight: 700;
			&:hover, &.router-link-exact-active {
				text-decoration: underline;
			}
		}
	}
}
</style>


<script>
export default {
	name: 'Footer'
}
</script>
